import React from "react";
import "./styles.css";
import WhatsappInfo from "../../whatsapp-info";
import WhatsappPricing from "../../whatsapp-pricing";
import Footer from "../../UI/footer";
import Plans from "../../plans";
import Press from "../../press";
import { tableHeaders, tableArray } from "../../../constants/contents";

function Pricing() {
  return (
    <div className="pricing">
      <h1 className="title-page">Tenemos un plan para todos</h1>
      <Plans />
      <WhatsappInfo />
      <WhatsappPricing headers={tableHeaders} data={tableArray} />
      <Press title={"Conoce los medios de prensa en los que hemos salido "} />
      <Footer />
    </div>
  );
}

export default Pricing;
